// extracted by mini-css-extract-plugin
module.exports = {"shortMessage":"OccupationLookup_shortMessage__MrMm7","referralMessageContainer":"OccupationLookup_referralMessageContainer__88yQa","maxWidth":"OccupationLookup_maxWidth__ykEdq"};